export const MODULESUBTITLE = [
    {
        userAnalytics: 'SPC-Dashboard',
        link: 'dashboard'
    },
    {
        label: 'statistics-continuous',
        code: '',
        translateCode: 'menuList.performance',
        userAnalytics: 'SPC-Continuous charts',
        link: 'statistics-continuous'
    },
    {
        label: 'capability-charts',
        code: '',
        translateCode: 'menuList.capability',
        userAnalytics: 'SPC-Capability charts',
        link: 'capability-charts'
    },
    {
        label: 'comparison',
        code: 'comparison',
        translateCode: 'menuList.comparison',
        userAnalytics: 'SPC-Comparison charts',
        link: 'comparison'
    },
    {
        label: 'summary',
        code: 'summary',
        translateCode: 'menuList.summary',
        userAnalytics: 'SPC-Summary charts',
        link: 'summary'
    },
    // {
    //     label: 'manual-entry',
    //     code: 'manual-entry',
    //     translateCode: 'menuList.manual_entry',
    //     userAnalytics: 'SPC-Manual Entry',
    //     link: 'manual-entry'
    // },
    {
        label: 'trends',
        code: 'trends',
        translateCode: 'menuList.trends',
        userAnalytics: 'Traceability-Trends',
        link: 'trends'
    },
    {
        label: 'downloads',
        code: 'downloads',
        translateCode: 'menuList.download',
        userAnalytics: 'Traceability-Download',
        link: 'downloads'
    },
    {
        label: 'ga-dashboard',
        code: 'ga-dashboard',
        translateCode: 'menuList.dashboard',
        userAnalytics: 'GA-Dashboard',
        link: 'ga-dashboard'
    },
    {
        label: 'ga-charts',
        code: 'ga-charts',
        translateCode: 'menuList.process_charts',
        userAnalytics: 'GA-Charts',
        link: 'ga-charts'
    },
    // {
    //     label: 'da',
    //     code: 'da',
    //     translateCode: 'menuList.batch',
    //     userAnalytics: 'DA-Batch charts',
    //     link: 'da'
    // },
    {
        label: 'line',
        code: 'line',
        translateCode: 'menuList.line',
        userAnalytics: 'Line-Configurator',
        link: 'line'
    },
    {
        label: 'machine',
        code: 'machine',
        translateCode: 'menuList.machine',
        userAnalytics: 'Machine-Configurator',
        link: 'machine'
    },
    {
        label: 'parameter',
        code: 'parameter',
        translateCode: 'menuList.parameter',
        userAnalytics: 'Parameter-Configurator',
        link: 'parameter'
    },
    {
        label: 'run',
        code: 'run',
        translateCode: 'menuList.run',
        userAnalytics: 'Production Run-Configurator',
        link: 'run'
    },
    {
        label: 'alert',
        code: 'alert',
        translateCode: 'menuList.alert',
        userAnalytics: 'Alert-Configurator',
        link: 'alert'
    },
    {
        label: 'ga',
        code: 'ga',
        translateCode: 'menuList.ega_settings',
        userAnalytics: 'GA-Configurator',
        link: 'ga'
    },
    {
        label: 'sku',
        code: 'sku',
        translateCode: 'menuList.sku',
        userAnalytics: 'SKU-Configurator',
        link: 'sku'
    },
    {
        label: 'enable-db',
        code: 'enable-db',
        translateCode: 'menuList.enable_db',
        userAnalytics: 'Enable Dashboard-Configurator',
        link: 'enable-db'
    },
    {
        label: 'pbir',
        code: 'pbir',
        translateCode: 'menuList.power_bi_report',
        userAnalytics: 'Power BI Report',
        link: 'pbir'
    },



    {
        label: 'reports-user-configuration',
        code: 'reports-user-configuration',
        translateCode: 'menuList.reports_user_configuration',
        userAnalytics: 'Reports User Configuration',
        link: 'reports-user-configuration'
    },






    {
        label: 'l1-db',
        code: 'l1-db',
        translateCode: 'menuList.l1_dashboard',
        userAnalytics: 'L1 Dashboard',
        link: 'l1-db'
    },
    {
        label: 'esc',
        code: 'esc',
        translateCode: 'menuList.ega_shift_configurator',
        userAnalytics: 'Enable Shift-Configurator',
        link: 'esc'
    },
    {
        label: 'bgbu',
        code: 'bgbu',
        translateCode: 'menuList.bg_bu_configurator',
        userAnalytics: 'BG BU Configurator',
        link: 'bgbu'
    },
    {
        label: 'parameterization',
        code: 'parameterization',
        translateCode: 'menuList.parameterization',
        userAnalytics: 'parameterization Configurator',
        link: 'parameterization'
    },
    {
        label: 'usecaselistview',
        code: 'usecaselistview',
        translateCode: 'menuList.use_case_list_view',
        userAnalytics: 'usecaselistview Configurator',
        link: 'usecaselistview'
    },
    {
        label: 'usecasetrainingview',
        code: 'usecasetrainingview',
        translateCode: 'menuList.use_case_training_view',
        userAnalytics: 'usecasetrainingview Configurator',
        link: 'usecasetrainingview'
    },
    {
        label: 'Individual_model_performance',
        code: 'Individual_model_performance',
        translateCode: 'menuList.Individual_model_performance',
        userAnalytics: 'Individual_model_performance Configurator',
        link: 'Individual_model_performance'
    },
    {
        label: 'usage-report',
        code: 'usage-report',
        translateCode: 'menuList.usage_report',
        userAnalytics: 'SPC-Usage Report',
        link: 'usage-report'
    },
    {
        label: 'batch-report',
        code: 'batch-report',
        translateCode: 'menuList.batch_report',
        userAnalytics: 'SPC-batch Report',
        link: 'batch-report'
    },
    {
        label: 'ga-report',
        code: 'ga-report',
        translateCode: 'menuList.ga_report',
        userAnalytics: 'SPC-Ga Report',
        link: 'ga-report'
    },
    {
        label: 'ga-summary',
        code: 'ga-summary',
        translateCode: 'menuList.ga_summary',
        userAnalytics: 'SPC-Ga Summary',
        link: 'ga-summary'
    },
    {
        label: 'scatter-chart',
        code: 'scatter-chart',
        translateCode: 'menuList.scatter-chart',
        userAnalytics: 'SPC-Scatter Chart',
        link: 'scatter-chart'
    },
    {
        label: 'corellation-chart',
        code: 'corellation-chart',
        translateCode: 'menuList.corellation-chart',
        userAnalytics: 'SPC-Corellation Chart',
        link: 'corellation-chart'
    },
    {
        label: 'process-chart',
        code: 'process-chart',
        translateCode: 'menuList.process-chart',
        userAnalytics: 'SPC-Corellation Chart',
        link: 'process-chart'
    },
    {
        label: 'comparison',
        code: 'comparison',
        translateCode: 'menuList.comparison',
        userAnalytics: 'SPC-Corellation Chart',
        link: 'comparison'
    },
    {
        label: 'ga-scatter-chart',
        code: 'ga-scatter-chart',
        translateCode: 'menuList.ga-scatter-chart',
        userAnalytics: 'SPC-Ga Scatter Chart',
        link: 'ga-scatter-chart'
    },
    {
        label: 'compare',
        code: 'compare',
        translateCode: 'menuList.comparison',
        userAnalytics: 'SPC-Ga Scatter Chart',
        link: 'qo'
    },
    {
        label: 'summary-view',
        code: 'summary-view',
        translateCode: 'menuList.summary-view',
        userAnalytics: 'Summary View',
        link: 'summary-view'
    },
    {
        label: 'use-case-view',
        code: 'use-case-view',
        translateCode: 'menuList.use-case-view',
        userAnalytics: 'Use Case View',
        link: 'use-case-view'
    },
    {
        label: 'zoom-in-view',
        code: 'zoom-in-view',
        translateCode: 'menuList.zoom-in-view',
        userAnalytics: 'Zoom In View',
        link: 'zoom-in-view'
    }
];
